export enum AwardProcedureState {
  Draft = "DRAFT",
  Active = "ACTIVE",
  Completed = "COMPLETED",
  Cancelled = "CANCELLED",
}
